import type { LinkMap } from "@saflib/links";

const subdomain = "account";

export const accountLinks: LinkMap = {
  // BEGIN WORKFLOW AREA page-links FOR vue/add-view
  home: {
    subdomain,
    path: "/",
  },
  /** Kratos name / phone traits (settings `profile` group, non-email fields). */
  profile: {
    subdomain,
    path: "/profile",
    params: ["flow", "return_to"],
  },
  /** Kratos identity email (settings `profile` group, email field). */
  email: {
    subdomain,
    path: "/email",
    params: ["flow", "return_to"],
  },
  password: {
    subdomain,
    path: "/password",
    params: ["flow", "return_to"],
  },
  /** Kratos TOTP (authenticator app) setup / unlink — admin account security. */
  mfa: {
    subdomain,
    path: "/mfa",
    params: ["flow", "return_to"],
  },
  organization: {
    subdomain,
    path: "/organization",
  },
  support: {
    subdomain,
    path: "/support",
  },
  // END WORKFLOW AREA
};
